import {
  activityDetailRes,
  calendarEntryData,
  cardDetailRes,
  courseCreditsData,
  homeEntryData,
} from '@/pageComponents/RenewalCoursesDetail/mock';

import client from './axios';
import {
  ActivityData,
  ActivityDetailReq,
  ActivityResult,
  CardDetailType,
  CourseCreditsEntryType,
  HomeEntryType,
  OrderPayload,
  RenewalEntriesType,
  Subject,
  SubjectsRep,
} from './types/renewal';

// mock数据开关
let useMock = undefined;

if (typeof window !== 'undefined') {
  useMock = window.localStorage.getItem('mock');
}

// 1. 首页自主续费活动入口
export const getHomeEntry = () => {
  if (useMock) {
    return Promise.resolve(homeEntryData as HomeEntryType);
  }
  return client.get<any, ActivityResult<HomeEntryType>>(`api/student/activity/home/entry`).then((res) => res?.content);
};

// 2. 课表自主续费活动动入口
export const getCalendarEntry = () => {
  if (useMock) {
    return Promise.resolve(calendarEntryData);
  }
  return client
    .get<any, ActivityResult<{ renewalEntries?: RenewalEntriesType[] }>>('api/student/activity/calendar/entry')
    .then((res) => res?.content);
};

// 3. 课时自动续费活动入口
export const getCourseCreditsEntry = () => {
  if (useMock) {
    return Promise.resolve(courseCreditsData as CourseCreditsEntryType);
  }
  return client
    .get<any, ActivityResult<CourseCreditsEntryType>>('api/student/activity/courseCredits/entry')
    .then((res) => res?.content);
};

// 4. 自主续费活动详情页
export const activityDetail = (data: ActivityDetailReq) => {
  if (useMock) {
    return Promise.resolve(activityDetailRes as ActivityData);
  }
  return client
    .post<any, ActivityResult<ActivityData>>('api/student/activity/detail', data)
    .then((res) => res?.content);
};

// 5. 获取卡片详情
export const cardDetail = (data: { courseCredits: number; subject: Subject }) => {
  if (useMock) {
    return Promise.resolve(cardDetailRes);
  }
  return client
    .post<any, ActivityResult<CardDetailType>>('api/student/activity/card/detail', data)
    .then((res) => res?.content);
};

// 6. 自主续费下单
export const orderCreate = (data: OrderPayload) => {
  if (useMock) {
    return Promise.resolve({ orderId: '0069e9bd-f9a4-4508-8166-eb69bd8548d6' });
  }
  return client
    .post<OrderPayload, ActivityResult<{ orderId: string }>>('api/student/activity/order/create', data)
    .then((res) => res?.content);
};

// 7. 获取科目列表
export const getSubjects = (activityId: string) => {
  if (useMock) {
    return Promise.resolve({
      subjects: ['CHINESE', 'MATH'],
      cuRemaining: {
        chinese: 4.0,
        math: 3.0,
        english: 7.0,
      },
    });
  }
  return client
    .get<any, ActivityResult<SubjectsRep>>(`api/student/activity/subjects/${activityId}`)
    .then((res) => res?.content);
};
